export default {
  adaptive: {
    sm: '@media screen and (max-width: 920px)',
  },
}
